import type { FC } from 'react'
import React, { useCallback, useEffect, useState } from 'react'
import type { FilterValue } from '@context/category-filters'
import { FilterTag } from '@components/category/FilterTag'
import { useTranslate } from '@hooks/useTranslation'
import { compose, find, pathOr, propEq, propOr } from 'ramda'
import { CwsP } from '@components/cws'
import { useInitialData } from '@context/initialDataContext'

interface CategoryFilterGroup {
  filtersData: FilterValue[]
  onClose: (value: FilterValue) => void
}
type tGroup = {
  [key: string]: FilterValue[]
}
const CategoryFilter: FC<CategoryFilterGroup> = ({ filtersData, onClose }) => {
  const { translate } = useTranslate()
  const {
    initialData: { tagGroups },
  } = useInitialData()

  const getFilterDescription = useCallback(
    (facetNumber: number, defaultName: string): string => {
      // @ts-ignore
      return compose(propOr(defaultName, 'description'), find(propEq('facetNumber', facetNumber)))(tagGroups)
    },
    [tagGroups]
  )

  if (filtersData.length === 1) {
    const [{ name, query, group, id }] = filtersData

    const title = getFilterDescription(parseInt(group ?? '0'), name)
    return (
      <FilterTag filterName={title} value={translate(id)} onClose={onClose.bind(this, { name, query, group, id })} />
    )
  }

  const title = `${getFilterDescription(parseInt(filtersData[0].group ?? '0'), filtersData[0].name)} ${translate(
    'w2.filters.group.postfix'
  )}`

  return (
    <div className="flex-col gap-3 h-7 overflow-hidden hover:overflow-auto hover:h-fit bg-midnight text-white">
      <CwsP color="white" size="small" className="text-center w-full cws-py-2 cws-pt-4">
        {title}
      </CwsP>
      <div>
        {filtersData.map(({ name, query, group, id }) => {
          const title = getFilterDescription(parseInt(group ?? '0'), name)
          return (
            <FilterTag
              key={`${name}-${query}-${id}`}
              filterName={title}
              value={translate(id)}
              onClose={onClose.bind(this, { name, query, group, id })}
            />
          )
        })}
      </div>
    </div>
  )
}
export const CategoryFilterGroup: FC<CategoryFilterGroup> = ({ filtersData, onClose }) => {
  const [filterGroupData, setFilterGroupData] = useState<FilterValue[][]>([])
  useEffect(() => {
    const group: tGroup = {}
    filtersData.map((item) => {
      group[item.name] = [...(group[item.name] ?? []), item]
    })
    setFilterGroupData(
      Object.keys(group).map((key) => {
        return group[key]
      })
    )
  }, [filtersData])

  return (
    <>
      {filterGroupData.map((filtersData, idx) => {
        return (
          <CategoryFilter key={pathOr(idx, ['0', 'id'], filtersData)} filtersData={filtersData} onClose={onClose} />
        )
      })}
    </>
  )
}
